import { ArticleSearchParams } from '@obeta/models/lib/models/Search'
import { useArticlesSearchProvider } from './useArticleSearchProvider'

export const useSuppliers = (p: { searchParams?: ArticleSearchParams }) => {
  const { suppliersResult, isFetching } = useArticlesSearchProvider()
  return {
    suppliers: suppliersResult,
    loading: isFetching,
  }
}
